import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

import { titleStyles } from "./chart-header";

export const breakdownTableContainerStyles = css`
  margin: 0 -20px -20px -20px;
  border-top: solid 1px ${withVar(DesignToken.BorderBasicPrimary)};
`;

interface IStyledIconProps {
  isOpen: boolean;
  disableExpand?: boolean;
}

export const StyledIconWrapper = styled.div<IStyledIconProps>`
  transform: rotate(
    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => (props.isOpen ? 90 : 0)
    }deg
  );
  transition: transform 300ms;
  margin-right: 15px;
  cursor: ${(props: IStyledIconProps): string => (props.disableExpand ? "default" : "pointer")};
  opacity: ${(props: IStyledIconProps): number => (props.disableExpand ? 0.5 : 1)};
`;

export const headerStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
`;

export const headerTitleStyles = [
  titleStyles,
  css`
    flex: 0 0 auto;
    cursor: pointer;
    min-height: 34px;

    &.disabled {
      cursor: default;
    }
  `,
];
